import axios from "axios";
const http = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  timeout: 100000,
  headers: {"Access-Control-Allow-Origin": "*" ,
  "Content-Type": 'application/json',}
});

export default http;
